export class GenericPlace {
  public id: number;
  public latitud: number;
  public longitud: number;
  public nombreDireccion: string;
  public placeId: string;
  public ciudad: string;
  public codigoPostal: string;
  public descripcion: string;
  public piso: string;
  public departamento: string;
  public provincia: string;
  public esDepartamento: boolean;
  public pais: string;

  constructor() {
    this.latitud = 0;
    this.longitud = 0;
    this.nombreDireccion = '';
    this.placeId = '';
    this.ciudad = '';
    this.codigoPostal = '';
    this.descripcion = '';
    this.piso = '';
    this.departamento = '';
    this.provincia = '';
    this.esDepartamento = false;
    this.pais = '';
  }
}
